import script from "./ContactDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactDetails.vue?vue&type=script&setup=true&lang=js"

import "./ContactDetails.vue?vue&type=style&index=0&id=89e73db4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89e73db4"]])

export default __exports__